import { useEffect, useRef } from "react";

// Hook: adds `in-view` class to descendants with `.reveal` when they enter viewport
export function useReveal() {
  const ref = useRef(null);

  useEffect(() => {
    const root = ref.current || document;
    const els = root.querySelectorAll(".reveal");
    if (!els.length) return;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in-view");
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );

    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return ref;
}
